export function getAnalyticsContentFromRefs(refs, componentName) {
  return refs.map(function (ref) {
    var _ref$current;
    return (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.textContent;
  }).find(function (textContent) {
    return textContent;
  });
}
export default getAnalyticsContentFromRefs;